import { formatNumber } from "./formatNumber";

export class Unit {
  private unit: number;
  private label: string;
  private precision: number;

  constructor(unit: number, label: string, precision: number) {
    this.unit = unit;
    this.label = label;
    this.precision = precision;
  }

  getUnit = () => this.unit;
  getLabel = () => this.label;
  getPrecision = () => this.precision;
}

export class WeightUnit extends Unit {}
export class DistanceUnit extends Unit {}

const g = new WeightUnit(1, "g", 0);
const kg = new WeightUnit(g.getUnit() * 1000, "kg", 3);
const lbs = new WeightUnit(kg.getUnit() * 0.453592, "lbs", 3);
export const WeightUnits = { g, kg, lbs };

const mm = new DistanceUnit(1, "mm", 0);
const m = new DistanceUnit(mm.getUnit() * 1000, "m", 3);
const km = new DistanceUnit(m.getUnit() * 1000, "km", 6);
const inch = new DistanceUnit(mm.getUnit() * 25.4, "inch", 2);
const ft = new DistanceUnit(m.getUnit() * 0.3048, "ft", 3);
export const DistanceUnits = { mm, m, km, inch, ft };

export class ValueWithUnit {
  value: number | null;
  unit: Unit;

  constructor(value: number | null, unit: Unit) {
    this.value = value;
    this.unit = unit;
  }

  protected calc(toUnit: Unit): number | null {
    if (this.value !== null) {
      return this.value * (this.unit.getUnit() / toUnit.getUnit());
    }
    return null;
  }

  readableValue = (): string => {
    if (this.value !== null) {
      return this.value.toFixed(this.unit.getPrecision());
    }
    return "";
  };

  toString = (): string => {
    if (this.value !== null) {
      const u = this.unit;
      return `${formatNumber(parseFloat(this.value.toFixed(u.getPrecision())))} ${u.getLabel()}`;
    }
    return "";
  };
}

export class Weight extends ValueWithUnit {
  convert = (toUnit: WeightUnit): Weight => {
    return new Weight(this.calc(toUnit), toUnit);
  };
}

export class Distance extends ValueWithUnit {
  convert = (toUnit: DistanceUnit): Distance => new Distance(this.calc(toUnit), toUnit);
}
